/**
 * Header of the sub-screens (Send / Receive / History): a "back"
 * chip on the left and an optional slot on the right. Minimal and consistent.
 */

import { Link } from "@tanstack/solid-router";
import { ArrowLeft } from "@fleet/icons";
import type { JSX, ParentComponent } from "solid-js";
import { Wordmark } from "@/components/brand/wordmark";

interface TopBarProps {
  /** Destination of the back button (defaults to home). */
  backTo?: string;
  /** Content on the right (action, chip…). If omitted, shows the iso-logo. */
  right?: JSX.Element;
}

export const TopBar: ParentComponent<TopBarProps> = (props) => (
  <header class="flex items-center justify-between pt-6">
    <Link
      to={props.backTo ?? "/"}
      aria-label="Back"
      class="press inline-flex h-10 w-10 items-center justify-center rounded-full border border-border bg-surface/60 text-muted-foreground backdrop-blur transition-colors hover:text-foreground"
    >
      <ArrowLeft class="h-5 w-5" />
    </Link>
    {props.right ?? <Wordmark iconOnly />}
  </header>
);
